/* globals cpac, $ */
if (typeof cpac !== 'undefined') {
    cpac.table = {
        duplicateLine: function (sourceRow, emptyInputs, where) {
            if (emptyInputs == undefined) { // set empty value for every input in new row
                emptyInputs = true;
            }
            if (where == undefined) {   // where to insert new row: before or after the source
                where = 'before';
            }

            var trRow = $(sourceRow);
            if (!trRow) {
                alert('Source line not found');
                return;
            }

            var newRow = trRow.cloneNode(true);

            if (emptyInputs) {
                var inputs = newRow.getElementsByTagName('input');
                if (inputs) {
                    for (var i=0; i<inputs.length; i++) {
                        inputs[i].value = '';
                    }
                }
            }

            switch (where) {
                case 'before':
                    trRow.parentNode.insertBefore(newRow, trRow);
                    break;

                case 'after':
                    cpac.table.insertAfter(trRow, newRow);
                    break;
            }

            return newRow;
        },
        insertAfter: function (row, newRow) {
            var nextRow = row.nextSibling;
            if (nextRow) {
                row.parentNode.insertBefore(newRow, nextRow);
            } else {
                row.parentNode.appendChild(newRow);
            }
        }
    }
}